import Image from 'next/image';

import { getImage } from '@/components/CrossChainSwaps/UserProfilesSection';

import { CHAIN_IDS_SUPPORT_INTENTS, NETWORK_NAME_PER_CHAIN_ID } from '@/constants/chain';

import { ChainAvatar } from '@/ui/Avatars/ChainAvatar';
import {
  MatchaTooltip,
  MatchaTooltipContent,
  MatchaTooltipPopover,
  MatchaTooltipTrigger,
} from '@/ui/MatchaTooltip';

import { StyledH2, StyledPrimaryCell } from '../../SwapTokens/utils';

const CHAINS = CHAIN_IDS_SUPPORT_INTENTS.map((chainId: number) => ({
  id: chainId,
  name: NETWORK_NAME_PER_CHAIN_ID[chainId],
}));

const tradersItems = [
  {
    url: getImage(3),
    label: 'Price execution maximalists',
  },
  {
    url: getImage(4),
    label: 'Meme coin flipping degens',
  },
  {
    url: getImage(5),
    label: 'MEV optimizers',
  },
];

export function MatchaAutoUsersSection() {
  return (
    <div className="desktop:flex gap-5 max-w-[1240px] mx-auto">
      <StyledPrimaryCell className="bg-token-gray-100 flex-col items-center pt-16 tablet:pt-14 pb-11 tablet:pb-7.5 px-6 text-center bg-[url(/images/matcha-auto/wave-lines.svg)] bg-no-repeat bg-top">
        <StyledH2 className="inline-block mb-12 tablet:mb-9">
          Available in {CHAINS.length} chains
          <span className="text-token-gray-600"> for supported trading pairs</span>
        </StyledH2>
        <ul className="max-w-[250px] flex flex-wrap justify-center gap-3">
          {CHAINS.map(({ id, name }) => (
            <MatchaTooltip key={name}>
              <MatchaTooltipTrigger>
                <li className="p-3 relative before:absolute before:top-0 before:right-0 before:bottom-0 before:left-0 before:rounded-2xl before:opacity-70 bg-token-color-gray-200 before:border before:content-[''] before:border-token-alphalight-300 first:ml-8 nth-[2]:mr-8">
                  <ChainAvatar chainId={id} alt={`${name} icon`} size={44} />
                </li>
              </MatchaTooltipTrigger>
              <MatchaTooltipContent>{name}</MatchaTooltipContent>
              <MatchaTooltipPopover sideOffset={5} />
            </MatchaTooltip>
          ))}
        </ul>
      </StyledPrimaryCell>

      <StyledPrimaryCell className="bg-token-gray-100 flex-col items-center pt-16 tablet:pt-14 pb-11 tablet:pb-7.5 px-6 text-center bg-[url(/images/matcha-auto/wave-lines-2.svg)] bg-no-repeat bg-[center_bottom]">
        <StyledH2>
          Who uses Matcha Auto?
          <span className="text-token-gray-600">Time-sensitive traders</span>
        </StyledH2>
        <ul className="flex flex-col tablet:flex-row items-center justify-evenly tablet:justify-around mt-4 tablet:mt-16 desktop:mt-6 w-full">
          {tradersItems.map(({ url, label }) => (
            <li
              key={label}
              className="flex flex-col items-center flex-[50%] min-w-[134px] max-w-[132px] tablet:flex-none tablet:mt-0 tablet:mb-0 tablet:first:mt-5 tablet:last:mt-8"
            >
              <Image
                src={url}
                alt=""
                height={60}
                width={60}
                className="stroke-token-gray-100 backface-hidden transform translate-z-0 filter-[drop-shadow(0px_4px_42px_rgba(0,0,0,0.06))_drop-shadow(0px_5px_6px_rgba(0,0,0,0.08))]"
              />
              <span className="text center mt-4 leading-6 text-token-gray-800">{label}</span>
            </li>
          ))}
        </ul>
      </StyledPrimaryCell>
    </div>
  );
}
